import OperatingSection from "../../../components/common/OperatingSection"
import BaseHeadline from "../../../components/general/BaseHeadline"
import { TFaq, THeading } from "../../../types/index"

type FaqSectionProps = {
    heading: THeading 
    faqItem: TFaq[]
}

export default function FaqSection({ heading, faqItem }: FaqSectionProps) {
    console.log("FAQ Items:", faqItem); // Debugging line to check the structure of faqItem
    const dataFaq = (faqItem ?? []).map((item, index) => ({
        attributes: {
            number: Number(`0${item.number}`) || Number(`0${index + 1}`),
            headline: item.headline,
            description: item.text,
        },
    }))

    return (
        <section className="py-20 px-4 w-full sm:px-8 xl:px-0">
            <div className="max-w-page mx-auto">
                <BaseHeadline
                    label={heading?.label}
                    headline={heading?.headline}
                    text={heading?.text}
                    center
                />

                <OperatingSection data={dataFaq} />
            </div>
        </section>
    )
}
